import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2Icon, GiftIcon, SparklesIcon } from 'lucide-react';
interface PriceInfo {
  code: string;
  price: string;
  oldPrice: string;
  locale: string;
}
const priceMap: Record<string, PriceInfo> = {
  CL: {
    code: 'CLP',
    price: '$15.990',
    oldPrice: '$34.990',
    locale: 'es-CL'
  },
  CO: {
    code: 'COP',
    price: '$54.900',
    oldPrice: '$119.900',
    locale: 'es-CO'
  },
  PE: {
    code: 'PEN',
    price: 'S/54.90',
    oldPrice: 'S/119.90',
    locale: 'es-PE'
  },
  MX: {
    code: 'MXN',
    price: '$309',
    oldPrice: '$649',
    locale: 'es-MX'
  },
  ES: {
    code: 'EUR',
    price: '€14.99',
    oldPrice: '€34.99',
    locale: 'es-ES'
  },
  AR: {
    code: 'ARS',
    price: '$14.990',
    oldPrice: '$32.990',
    locale: 'es-AR'
  },
  UY: {
    code: 'UYU',
    price: '$649',
    oldPrice: '$1.399',
    locale: 'es-UY'
  },
  BR: {
    code: 'BRL',
    price: 'R$79,90',
    oldPrice: 'R$169,90',
    locale: 'pt-BR'
  },
  US: {
    code: 'USD',
    price: '$14.99',
    oldPrice: '$34.99',
    locale: 'en-US'
  }
};
function detectPrice(): PriceInfo {
  const lang = navigator.language || 'es';
  const parts = lang.split('-');
  const country = parts.length > 1 ? parts[1].toUpperCase() : '';
  if (country && priceMap[country]) return priceMap[country];
  const langLower = lang.toLowerCase();
  if (langLower.startsWith('es')) {
    const tz = new Date().getTimezoneOffset();
    if (tz >= 180 && tz <= 240) return priceMap['AR'];
    if (tz >= 300 && tz <= 360) return priceMap['MX'];
    if (tz >= 240 && tz < 300) return priceMap['CO'];
    return priceMap['ES'];
  }
  if (langLower.startsWith('pt')) return priceMap['BR'];
  return priceMap['US'];
}
const included = ['Técnica', 'Táctica', 'Bandejas', 'Salidas de Pared', 'Juego Aéreo', 'Defensa', 'Transiciones', 'Estrategia', 'Saque', 'Voleas', 'Sesiones Completas', 'Análisis de Rival'];
const bonusList = ['Módulo de Físico', 'Juegos Reducidos', 'Recursos Prácticos para Entrenadores'];
export function OfferSection() {
  const checkoutUrl = 'https://pay.hotmart.com/A105284571O?checkoutMode=10';
  const [pricing, setPricing] = useState<PriceInfo>(priceMap['US']);
  useEffect(() => {
    setPricing(detectPrice());
  }, []);
  return <section id="compra" className="py-16 px-4" data-id="element-71">
      <div className="max-w-2xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-card border-2 border-primary/30 rounded-2xl overflow-hidden" data-id="element-73">
          {/* Header */}
          <div className="bg-primary/10 border-b border-primary/20 p-5 text-center" data-id="element-74">
            <h2 className="text-2xl md:text-3xl font-black" data-id="element-75">
              Megapack <span className="text-accent" data-id="element-76">Pádel Listo</span>
            </h2>
            <p className="text-sm text-gray-400 mt-1" data-id="element-77">
              Combo Completo — Acceso inmediato
            </p>
          </div>

          {/* Product image */}
          <div className="px-6 pt-6 flex justify-center" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/heLoZZWJL3TJgHxcNkBzoG/Combinacion_completa_para_entrenadores_de_padel.png" alt="Megapack Pádel Listo" className="w-full max-w-sm drop-shadow-[0_0_20px_rgba(132,204,22,0.12)]" style={{
            mixBlendMode: 'lighten'
          }} data-id="element-79" />
          </div>

          {/* Included modules */}
          <div className="px-6 pt-4 pb-2" data-id="element-80">
            <p className="text-sm font-bold text-gray-300 uppercase tracking-wide mb-3" data-id="element-81">
              12 módulos incluidos:
            </p>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 mb-4" data-id="element-82">
              {included.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-83">
                  <CheckCircle2Icon className="w-4 h-4 text-primary flex-shrink-0" data-id="element-84" />
                  <span className="text-sm" data-id="element-85">{item}</span>
                </div>)}
            </div>
          </div>

          {/* Bonuses */}
          <div className="px-6 pb-4" data-id="element-86">
            <div className="flex items-center gap-2 mb-3" data-id="element-87">
              <GiftIcon className="w-4 h-4 text-accent" data-id="element-88" />
              <p className="text-sm font-bold text-accent uppercase tracking-wide" data-id="element-89">
                + 3 Bonos GRATIS por hoy:
              </p>
            </div>
            <div className="space-y-1.5 mb-4" data-id="element-90">
              {bonusList.map((bonus, i) => <div key={i} className="flex items-center gap-2 bg-accent/5 rounded px-3 py-1.5" data-id="element-91">
                  <SparklesIcon className="w-4 h-4 text-accent flex-shrink-0" data-id="element-92" />
                  <span className="text-sm font-semibold" data-id="element-93">{bonus}</span>
                  <span className="ml-auto text-xs bg-accent/20 text-accent px-2 py-0.5 rounded font-bold" data-id="element-94">
                    GRATIS
                  </span>
                </div>)}
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gray-700 mx-6" data-id="element-95" />

          {/* Price + CTA */}
          <div className="p-6 text-center" data-id="element-96">
            <div className="bg-red-600/15 border border-red-500/40 rounded-lg px-4 py-2 inline-flex items-center gap-2 mb-4" data-id="element-97">
              <span className="text-xs text-red-300" data-id="element-98">Oferta termina en:</span>
              <CountdownTimer className="text-sm font-bold text-red-400" data-id="element-99" />
            </div>

            <div className="mb-5" data-id="element-100">
              <p className="text-gray-500 line-through text-xl" data-id="element-101">
                {pricing.oldPrice}
              </p>
              <p className="text-4xl md:text-5xl font-black text-primary my-1" data-id="element-102">
                {pricing.price}
              </p>
              <p className="text-xs text-gray-500" data-id="element-103">
                Precio especial por tiempo limitado
              </p>
            </div>

            <motion.a href={checkoutUrl} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="block w-full bg-primary hover:bg-green-600 text-white font-bold text-lg py-5 rounded-lg shadow-xl transition-all mb-3" data-id="element-104">
              🔥 Quiero el Megapack ahora
            </motion.a>

            <p className="text-xs text-gray-500" data-id="element-105">
              Pago seguro • Garantía 45 días • Descarga inmediata
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}